import { LangType } from "~/types/Data/Common/languages";

export default function useLocale() {
  const { localeProperties, locales, setLocale } = useI18n();
  const localeCookie = useCookie("locale-cookie");
  const nuxtApp = useNuxtApp();

  const currentLocale = computed(
    () => localeProperties.value as unknown as LangType,
  );
  const availableLocales = computed(() => {
    return locales.value.filter(
      (item) => nuxtApp.$langs?.includes(item.code) ?? [],
    ) as unknown as LangType[];
  });

  const setLang = (lang: LangType, refreshPage: boolean = false) => {
    if (availableLocales.value.find((item) => item.code === lang.code)) {
      localeCookie.value = lang.code;
      if (!refreshPage) {
        setLocale(lang.code);
        document.documentElement.setAttribute("dir", lang.dir);
      } else {
        reloadNuxtApp({ force: true });
      }
    } else {
      throw new Error(
        `'${lang.code} is not available. Check i18n configurations'`,
      );
    }
  };

  const initLocale = () => {
    if (localeCookie.value) {
      const storedCode = availableLocales.value.find(
        (item) => item.code === localeCookie.value,
      );
      if (storedCode) {
        setLang(storedCode);
      } else {
        setLang(availableLocales.value[0]);
      }
    } else {
      setLang(currentLocale.value);
    }
  };

  return {
    currentLocale,
    availableLocales,
    setLang,
    initLocale,
  };
}
